class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');

    const elements = {
      form: this.closest("form"),
      inputs: this.querySelectorAll('input[type="radio"]')
    };

    this.spinnerContainer = null;

    elements.inputs.forEach((element) => {
      element.addEventListener('change', () => {
        const variant = get_variant();
        const container = element.closest('.spinner-container');

        if (container) {
          container.classList.add('state--loading');
        }

        this.spinnerContainer = container;

        if (!variant) {
          this.removeSpinnerLoading();
          return;
        }

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);

        elements.form.querySelector("[name=id]").value = variant.id;

        this.onVariantChange(variant, element);
      });
    });

    const get_variant = () => {
      const variant_title = get_variant_title(elements.inputs);
      const variant = get_variant_by_title(variant_title);
      return variant;
    };

    const get_variant_title = (form_elements) => {
      let selectedValues = [];
      form_elements.forEach(el => {
        if (el.type === "radio" && el.checked) {
          selectedValues.push(el.value);
        }
      });
      const title = selectedValues.join(" / ").trim();
      return title;
    };

    const get_variant_by_title = (title) => {
      let selectedVariant = null;
      Theme.Liquid.product.variants.forEach((variant) => {
        if (title === variant.title) {
          selectedVariant = variant;
        }
      });
      return selectedVariant;
    };


    const variantDropdowns = this.querySelectorAll('.variants-dropdown');
    if (variantDropdowns.length > 0) {
      this.initVariantsDropdown();
    }
  }

  disconnectedCallback() {
    if (this._onDocumentClick) {
      document.removeEventListener('click', this._onDocumentClick);
      this._onDocumentClick = null;
    }
  }

  removeSpinnerLoading() {
    if (this.spinnerContainer) {
      this.spinnerContainer.classList.remove('state--loading');
      this.spinnerContainer = null;
    }
  }

  onVariantChange(variant, input) {
    if (!variant) {
      this.removeSpinnerLoading();
      return;
    }

    this.updateProductFormState(variant, input);
    this.updateDropdownState(input);
    this.updateButtonVariantState(input);

    this.removeSpinnerLoading();
  }

  updateProductFormState(variant, input) {
    const form = this.closest('form');
    const lowStockMessage = form?.querySelector('[data-low-stock-message]');
    const submitButton = form?.querySelector('[data-product-submit-button]');
    const submitText = form?.querySelector('[data-product-submit-text]');
    const isLowStock = variant.inventory_quantity <= 50 && variant.inventory_quantity > 0;

    if (lowStockMessage) {
      lowStockMessage.hidden = !isLowStock;
    }

    if (submitButton) {
      submitButton.disabled = !variant.available;
    }

    if (submitText) {
      submitText.textContent = variant.available ? 'Add to basket' : 'Out of stock';
    }
  }

  updateDropdownState(input) {
    const dropdown = input?.closest('.variants-dropdown');
    const optionName = dropdown?.dataset.option || input?.name;
    const optionWrapper = dropdown?.closest('.stack-1');
    const dropdownTriggerText = dropdown?.querySelector('[data-variant-dropdown-trigger-text]');
    const optionLabel = optionWrapper?.querySelector('[data-variant-option-label]');

    if (dropdownTriggerText && input?.value) {
      dropdownTriggerText.textContent = input.value;
      dropdownTriggerText.classList.remove('text--upper', 'small--size-0');
      dropdownTriggerText.classList.add('size--1');
    }

    if (optionLabel && optionName && input?.value) {
      optionLabel.textContent = `${optionName}: ${input.value}`;
    }
  }

  updateButtonVariantState(input) {
    const optionValues = input?.closest('.option-values');
    const variantOptions = optionValues?.querySelectorAll('.product-form-variant');
    const selectedInput = optionValues?.querySelector('input[type="radio"]:checked');
    const selectedVariantOption = selectedInput?.closest('.product-form-variant');
    const optionWrapper = optionValues?.closest('.stack');
    const optionLabel = optionWrapper?.querySelector('[data-variant-option-label]');
    const optionName = optionLabel?.dataset.optionName || input?.name;

    if (variantOptions) {
      variantOptions.forEach((option) => {
        option.classList.remove('selected');
      });
    }

    if (selectedVariantOption) {
      selectedVariantOption.classList.add('selected');
    }

    if (optionLabel && optionName && input?.value) {
      optionLabel.textContent = `${optionName}: ${input.value}`;
    }
  }

  initVariantsDropdown() {
    const dropdowns = this.querySelectorAll('.variants-dropdown');

    if (!this._onDocumentClick) {
      this._onDocumentClick = (e) => {
        const dropdown = e.target.closest('.variants-dropdown');
        if (dropdown && this.contains(dropdown)) {
          return;
        }

        const openLists = this.querySelectorAll('.variants-dropdown.is-open');
        openLists.forEach((openList) => {
          openList.classList.remove('is-open');
        });
      };

      document.addEventListener('click', this._onDocumentClick);
    }

    dropdowns.forEach((dropdown, index) => {

      const trigger = dropdown.querySelector('.variants-dropdown-trigger');
      const list = dropdown.querySelector('.variants-dropdown-list');

      if (!trigger) {
        return;
      }

      if (!list) {
        return;
      }

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = dropdown.classList.contains('is-open');

        const openLists = this.querySelectorAll('.variants-dropdown.is-open');
        openLists.forEach(openList => {
          if (openList !== dropdown) {
            openList.classList.remove('is-open');
          }
        });

        dropdown.classList.toggle('is-open', !isOpen);
      });

      list.addEventListener('click', (e) => {
        e.stopPropagation();
        const label = e.target.closest('label');
        if (!label) {
          return;
        }

        const inputId = label.getAttribute('for');
        const input = inputId ? dropdown.querySelector('#' + CSS.escape(inputId)) : null;

        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        dropdown.classList.remove('is-open');
      });

    });
  }
}

customElements.define("product-form-variants", ProductFormVariants)


class ProductFormVariantsCard extends HTMLElement {
  constructor() {
    super();

    const dropdowns = this.querySelectorAll('.variants-dropdown-card');

    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('.variants-dropdown-card-trigger');
      if (trigger) {
        e.preventDefault();
        const dropdown = trigger.closest('.variants-dropdown-card');
        dropdowns.forEach(otherDropdown => {
          if (otherDropdown !== dropdown) {
            otherDropdown.classList.remove('is-open');
          }
        });
        dropdown.classList.toggle('is-open');
        return;
      }

      const label = e.target.closest('.variants-dropdown-card-list label');
      if (label) {
        const dropdown = label.closest('.variants-dropdown-card');
        const form = dropdown.closest('form');
        const inputId = label.getAttribute('for');
        const input = inputId ? dropdown.querySelector('#' + CSS.escape(inputId)) : null;
        if (input) {
          input.checked = true;
          const trig = dropdown.querySelector('.variants-dropdown-card-trigger');
          if (trig) {
            const span = trig.querySelector('span');
            if (span) {
              span.textContent = label.textContent.trim();
            }
          }
          if (form) {
            const hiddenInput = form.querySelector('[name=id]');
            if (hiddenInput && input.dataset.variantId) {
              hiddenInput.value = input.dataset.variantId;
            }
          }
        }
        dropdown.classList.remove('is-open');
        return;
      }

      if (!e.target.closest('.variants-dropdown-card')) {
        dropdowns.forEach(dropdown => {
          dropdown.classList.remove('is-open');
        });
      }
    });
  }
}

customElements.define('product-form-variants-card', ProductFormVariantsCard);
